export default __webpack_public_path__ + "static/media/webinar_as_disciple.5d9efbdd.svg";